
let PaymentRoutes = [
  {
    // 缴费管理
    path: '4801',
    name: '4801',
    component: () => import('@/pages/Payment/PaymentInfo/PaymentInfo')
  },
  {
    // 消费开放设置
    path: '4802',
    name: '4802',
    component: () => import('@/pages/Payment/OpenConsume/OpenConsume')
  },
  {
    // 缴费明细
    path: '4811',
    name: '4811',
    component: () => import('@/pages/Payment/PaymentRecord/PaymentRecord')
  },
  {
    // 缴费统计
    path: '4812',
    name: '4812',
    component: () => import('@/pages/Payment/PaymentStatistics/PaymentStatistics')
  },
  {
    // 缴费日报表
    path: '4813',
    name: '4813',
    component: () => import('@/pages/Payment/PaymentDayReport/PaymentDayReport')
  }
]

export {
  PaymentRoutes
}



// WEBPACK FOOTER //
// ./src/router/PaymentRoutes.js